<div class="points-selector" role="radiogroup" aria-label="Startup points">
  <button
    *ngFor="let score of scores"
    type="button"
    pButton
    role="radio"
    class="p-button-sm p-button-outlined score-button"
    [class.p-button-success]="value === score"
    [attr.aria-checked]="value === score"
    [attr.aria-label]="score + ' out of 10 points'"
    [disabled]="disabled"
    [label]="score.toString()"
    (click)="select(score)"
  ></button>
</div>

<div class="selected-score" aria-live="polite">
  Selected score: {{ value }} / 10
</div>
